<template>
  <div>
    <div v-if="treeData.length === 0" class="pt-16">
      Drag a file below to begin categorizing your files.
    </div>
    <draggable
      v-model="treeData"
      :group="group"
      ghost-class="ghost"
      v-bind="dragOptions"
      :class="{'h-64': treeData.length === 0}"
      item-key="id"
    >
      <template #item="{element}">
        <categorized-files-tree-node
          :collapse-all="collapseAll"
          :value="element"
          :group="group"
          :row-key="rowKey"
          class="cursor-grab"
        />
      </template>
    </draggable>
  </div>
</template>

<script>
  import Draggable from 'vuedraggable';
  import CategorizedFilesTreeNode from './CategorizedFilesTreeNode.vue';

  export default {
    components: {
      Draggable,
      CategorizedFilesTreeNode,
    },

    props: {
      data: {
        type: Array,
        default: () => [],
      },
      modelValue: { // Add Vue 3 modelValue prop
        type: Array,
        default: () => [],
      },
      group: {
        type: String,
        default: null,
      },
      rowKey: {
        type: String,
        default: 'key',
      },
      collapseAll: Boolean,
    },

    emits: ['input', 'update:modelValue'], // Add emits declaration

    data() {
      return {
        localValue: [...(this.modelValue || this.data)], // Support both patterns
      };
    },

    computed: {
      treeData: {
        get() {
          return this.modelValue || this.data; // Support both Vue 3 and Vue 2 patterns
        },
        set(val) {
          this.localValue = val;
          this.$emit('update:modelValue', val); // Vue 3 pattern
          this.$emit('input', val); // Vue 2 pattern for backward compatibility
        },
      },
      dragOptions() {
        return {
          animation: 200,
          group: 'files',
          disabled: false,
        };
      },
    },

    watch: {
      modelValue(value) { // Watch for Vue 3 modelValue changes
        if (value) {
          this.localValue = [...value];
        }
      },
      data(value) { // Keep watching data for backward compatibility
        if (value) {
          this.localValue = [...value];
        }
      },
    },
  };
</script>